import { render, staticRenderFns } from "./spec-edit.vue?vue&type=template&id=2d6966b9&scoped=true"
import script from "./spec-edit.vue?vue&type=script&lang=js"
export * from "./spec-edit.vue?vue&type=script&lang=js"
import style0 from "./spec-edit.vue?vue&type=style&index=0&id=2d6966b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6966b9",
  null
  
)

export default component.exports